export const textData = {
  title: 'Stowarzyszenie OD-DO',
  titleDescription:
    'Prowadzimy Dorosłe Dzieci Alkoholików (DDA) od odkrywania i akceptowania siebie do dokonywania własnych wyborów oraz brania odpowiedzialności za swoje życie.',
  titleAbout: 'O Stowarzyszeniu OD-DO',
  aboutDescription:
    'Wszystko zaczęło się od studiów w Instytucie Profilaktyki Społecznej i Resocjalizacji na Uniwersytecie Warszawskim. Tam się poznaliśmy i zaprzyjaźniliśmy. Na pewnym etapie naszego życia zawodowego stwierdziliśmy, że chcemy też stworzyć razem zespół psychoterapeutów.  Zdecydowaliśmy się wspólnie podjąć działania adresowane do młodych osób wzrastających w rodzinach dysfunkcjonalnych. Istniejemy jako Stowarzyszenie OD-DO od 19 października 2001r.',
};
